import React, {useEffect, useState} from 'react';
import AuthService from "../../../Services/auth/authAPI";
import CashierAPI from "../../../apis/cashierApi/CashierAPI";
import {toast} from "react-toastify";

const CashierDashboard = () => {

    const [loading, setLoading] = useState(true);
    const [setting, setSetting] = useState([]);
    const [me, setMe] = useState(AuthService.getAuthenticatedUser());
    const [boxUSB, setBoxUSB] = useState([]);
    const [boxCDF, setBoxCDF] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [cashAccounts, setCashAccounts] = useState([]);

    const fetchSetting = async () => {
        try{
            const data =  await CashierAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };

    const fetchCashAccounts = async () => {
        try{
            const data =  await CashierAPI.findCashAccounts();
            setCashAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };

    const getUSDCashBox = async () => {
        try{
            const data =  await CashierAPI.getUSBCashBox();
            setBoxUSB(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement de la casse USD !");
        }
    };

    const getCashAccounts = async () => {
        try{
            const data =  await CashierAPI.getCashAccounts();
            setAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };

    const getCDFCashBox = async () => {
        try{
            const data =  await CashierAPI.getCDFCashBox();
            setBoxCDF(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement de la casse FC !");
        }
    };


    useEffect(() => {
        fetchSetting();
        getUSDCashBox();
        getCDFCashBox();
        getCashAccounts();
        fetchCashAccounts();
        return () => console.log("...");
    },[]);

    let counter = 1;

    return (
        <div className="container mt-2">
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card p-2">
                        <div className="card-body justify-content-center">
                            <h3>Bonjour, <b>{me ? (<>{me.user.name}</>):(<></>)}</b></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-5">
                    <div className="card">
                        <div className="card-body">
                            <div className="row d-flex justify-content-center border-dashed-bottom pb-3">
                                <div className="col-9">
                                    <p className="text-dark mb-0 fw-semibold fs-14">Les comptes</p>
                                    <h3 className="mt-2 mb-0 fw-bold">{accounts && accounts.length}</h3>
                                </div>
                                <div className="col-3 align-self-center">
                                    <div
                                        className="d-flex justify-content-center align-items-center thumb-xl bg-light rounded-circle mx-auto">
                                        <i className="iconoir-clock h1 align-self-center mb-0 text-secondary"></i>
                                    </div>
                                </div>
                            </div>
                            <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" colSpan="3">Designation</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>
                                {!loading &&<tbody>
                                {accounts && accounts.map((account) => (
                                    <tr key={account.id}>
                                        <td>{counter++}</td>
                                        <td colSpan="3"><b className="text-success">{account.compte}</b></td>
                                        <td></td>
                                    </tr>
                                ))
                                }

                                </tbody>}
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-7">
                    <div className="row">
                        {cashAccounts && cashAccounts.map((cashAccount) =>
                            <div className="col-md-4">
                                <div className="card bg-success-light">
                                    <div className="card-body p-3">
                                        <div className="row d-flex justify-content-center border-dashed-bottom pb-3">
                                            <div className="col-9">
                                                <p className="text-dark mb-0 fw-semibold fs-14">{cashAccount.name}</p>
                                                <h3 className="mt-2 mb-0 fw-bold">
                                                    {cashAccount.t_amount} {cashAccount.currency}
                                                </h3>
                                            </div>
                                            <div className="col-3 align-self-center">
                                                <div
                                                    className="d-flex justify-content-center align-items-center thumb-xl bg-light rounded-circle mx-auto">
                                                    <i
                                                        className="iconoir-percentage-circle h1 align-self-center mb-0 text-secondary"></i>
                                                </div>
                                            </div>
                                        </div>
                                        {/*<p className="mb-0 text-truncate text-muted mt-3"><span className="text-danger">8%</span>*/}
                                        {/*    Up Bounce Rate Weekly</p>*/}
                                    </div>
                                </div>
                            </div>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashierDashboard;